export const MOCK_SCAN_LIST_RESPONSE = {
  results: [
    {
      id: 'mock-scan-1',
      scan_seed: 'example.com',
      profile_name: 'Full Scan',
      description: 'Comprehensive security scan',
      status: 'completed',
      start_time: '2024-11-15T08:30:00Z',
      start_time_jalali: '1403/08/25 08:30',
      end_time: '2024-11-15T09:45:00Z',
    },
    {
      id: 'mock-scan-2',
      scan_seed: 'api.example.com',
      profile_name: 'API Scan',
      description: 'API endpoint security check',
      status: 'completed',
      start_time: '2024-11-14T14:00:00Z',
      start_time_jalali: '1403/08/24 14:00',
      end_time: '2024-11-14T14:52:00Z',
    },
    {
      id: 'mock-scan-3',
      scan_seed: 'shop.example.com',
      profile_name: 'Quick Scan',
      description: 'Lightweight surface scan',
      status: 'failed',
      start_time: '2024-11-13T10:15:00Z',
      start_time_jalali: '1403/08/23 10:15',
      end_time: '2024-11-13T10:22:00Z',
    },
    {
      id: 'mock-scan-4',
      scan_seed: 'mail.example.com',
      profile_name: 'Full Scan',
      description: 'Comprehensive security scan',
      status: 'running',
      start_time: '2024-11-16T07:00:00Z',
      start_time_jalali: '1403/08/26 07:00',
      end_time: null,
    },
  ],
  current_page: 1,
  total_pages: 1,
}

export const MOCK_SCAN_CHART_RESPONSE = {
  data: {
    total_tasks: 4,
    completed: 2,
    failed: 1,
  },
}
